const convertArea = (area, units) => {
  let output = '';
  let val = 0;
  if(units === 'ft/mi'){
    area = area * 10.7639;
    if(area > 27878400){
      val = (Math.round(area / 27878400 * 100) / 100);
      output = val + ' mi<sup>2</sup>';
    }else{
      val = (Math.round(area * 100) / 100);
      output = val + ' ft<sup>2</sup>';
    }
  }else if(units === 'acres'){
    area = area / 4046.86;
    val = (Math.round(area * 100) / 100);
    output = val + ' acres';
  }else if(units === 'hectares'){
    area = area / 10000;
    val = (Math.round(area * 100) / 100);
    output = val + ' hectares';
  }else{
    if(area > 10000){
      val = (Math.round(area / 1000000 * 100) / 100);
      output = val + ' km<sup>2</sup>';
    }else{
      val = (Math.round(area * 100) / 100);
      output = val + ' m<sup>2</sup>';
    }
  }
  return {output: output, val: val};
}

const convertDistance = (length, units) => {
  let output = '';
  let val = 0;
  if(units === 'ft/mi'){
    length = length * 3.28084;
    if(length > 5280){
      val = (Math.round(length / 5280 * 100) / 100);
      output = val + ' mi';
    }else{
      val = (Math.round(length * 100) / 100);
      output = val + ' ft';
    }
  }else{
    if(length > 100){
      val = (Math.round(length / 1000 * 100) / 100);
      output = val + ' km';
    }else{
      val = (Math.round(length * 100) / 100);
      output = val + ' m';
    }
  }
  return {output: output, val: val};
}

export { convertArea, convertDistance };